module.exports = __webpack_public_path__ + "img/M4_JKKP_06.5cb1da08.png";